import * as React from "react";
import { $, merge } from "glamor";
import { Card, ListItem, ListItemIcon } from "@material-ui/core";
import Checkbox from "material-ui/Checkbox";
import { formatMessage } from "lib/globalize-util";
import DragHandleIcon from "@material-ui/icons/DragHandle";
export interface IProps {
    text: string;
    checked: boolean;
    id: string;
    onCheck: (_, checked: boolean) => void;
}
const styles = merge(
    $(" .MuiListItem-root", {
        padding: "4px 16px",
    }),
    $(" .optionsCheck", {
        maxWidth: "15%",
    }),
    $(" .optionsCheckLabel", {
        float: "left",
        position: "relative",
        display: "block",
        lineHeight: "24px",
        color: "rgb(45, 45, 45)",
        fontFamily: "Lato, sans-serif",
        fontSize: "14px",
        fontWeight: "400",
        width: "calc(100% - 60px)",
    })
);

export const DimensionValueCard = React.forwardRef<HTMLDivElement, IProps>(({ text, checked, onCheck, id }, ref) => {
    return (
        <div {...styles}>
            <Card className="card">
                <ListItem>
                    <div className="dimensionCheckBox">
                        <ListItemIcon ref={ref} className="dragHandler">
                            <DragHandleIcon />
                        </ListItemIcon>
                        <Checkbox className="optionsCheck" checked={checked} value={id} onCheck={onCheck} />
                        <span className="optionsCheckLabel">
                            {text.length > 0 ? text : `[${formatMessage("Blank")}]`}
                        </span>
                    </div>
                </ListItem>
            </Card>
        </div>
    );
});

DimensionValueCard.displayName = "DimensionValueCard";
